import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import {
  ApplicationConfig,
  isDevMode,
  LOCALE_ID,
} from '@angular/core';
import {
  PreloadAllModules,
  provideRouter,
  TitleStrategy,
  withPreloading,
} from '@angular/router';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';

import { provideHttpClient } from "@angular/common/http";
import { provideServiceWorker } from '@angular/service-worker';
import { provideIcons, provideNgIconsConfig } from '@ng-icons/core';
import * as iconoirIcons from '@ng-icons/iconoir';
import * as materialIcons from '@ng-icons/material-icons/baseline';
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';
import { provideHighlightOptions } from 'ngx-highlightjs';
import { routes } from './app.routes';
import { AuthService } from "./core/auth/auth.service";
import { OverrideSocialAuthService } from "./core/auth/override-social-auth.service";
import { provideSessionBootstrap } from "./core/auth/session-bootstrap";
import { DATE_CONFIG } from "./core/configs/data-config";
import { PageTitleStrategy } from "./core/page-title.strategy";
import { SupabaseService } from "./core/supabase.service";
import { withCoffeeRouteTransitions } from "./services/route-transition.service";

// Combine all Iconoir and Material icons
const ALL_ICONS = {
  ...iconoirIcons,
  ...materialIcons
};

registerLocaleData(localeFr);

export const appConfig: ApplicationConfig = {
  providers: [
    provideAnimationsAsync(),
    // Connexion Google (domaines web-atrio.com seulement, cf. OverrideSocialAuthService).
    {
      provide: 'SocialAuthServiceConfig',
      useClass: OverrideSocialAuthService,
    },
    provideHttpClient(),
    SupabaseService,
    AuthService,
    // Bloque le bootstrap le temps de restaurer la session et de charger
    // profil + organisation + abonnement + rôles : les guards sont ensuite synchrones.
    provideSessionBootstrap(),
    ...DATE_CONFIG,
    provideRouter(
      routes,
      // View Transitions du routeur, personnalisées : front de café entre les pages
      // (services/route-transition.service.ts).
      withCoffeeRouteTransitions(),
      withPreloading(PreloadAllModules),
    ),
    provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:10000'
    }),
    provideCharts(withDefaultRegisterables()), { provide: LOCALE_ID, useValue: 'fr' }, provideNgIconsConfig({ size: '1em' }), provideIcons(ALL_ICONS), provideHighlightOptions({
      fullLibraryLoader: () => import('highlight.js')
    }),
    { provide: TitleStrategy, useClass: PageTitleStrategy },
  ]
};

